import { Chain } from '@ankr.com/chains-list';

export const getBeaconChains = (chains: Chain[] = []): Chain[] =>
  chains.flatMap(
    ({
      beacons = [],
      devnets = [],
      extenders = [],
      extensions = [],
      testnets = [],
    }) => [
      ...beacons,
      ...getBeaconChains(devnets),
      ...getBeaconChains(extenders),
      ...getBeaconChains(testnets),
      ...getBeaconChains(extensions),
    ],
  );
